export default "__VITE_ASSET__B$pTIT4U__"